module.exports = "/static/assets/4c04f0198c7c4910c95d5dc814024c7f.png";